import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import WrongIcon from '../icons/CrossIcon'
import FailingIcon from '../icons/FailingIcon'
import PendingIcon from '../icons/PendingIcon'
import RightIcon from '../icons/RightIcon'
import { ORDER_STATUS, ORDER_TYPE } from 'app/farmer360/constants/order'

interface Props {
  deliveryDate: string | null
  status: string
  onlinePaymentStatus: string
  orderType: ORDER_TYPE
}

interface OrderSuccessfulProps {
  isPrebook?: boolean
}

const OrderSuccessful = ({ isPrebook = false }: OrderSuccessfulProps) => {
  return (
    <View style={[styles.section, { backgroundColor: '#E3F5CE' }]}>
      <View style={[styles.iconWrapper, { backgroundColor: '#4CAF50' }]}>
        <RightIcon width={48} height={48} fill="#E3F5CE" />
      </View>
      <Text style={[styles.text, { color: '#4CAF50' }]}>
        {isPrebook ? 'Pre-booked order Placed' : 'Successfully order placed'}
      </Text>
    </View>
  )
}

const OrderDelivered = ({
  deliveryDate,
  orderType,
}: {
  deliveryDate: string | null
  orderType: ORDER_TYPE
}) => {
  const isPickupOrder = orderType === ORDER_TYPE.SELF_PICKUP
  const label = isPickupOrder
    ? 'Order Picked Up'
    : deliveryDate
      ? `Delivered on ${deliveryDate}`
      : 'Delivered'

  return (
    <View style={[styles.section, { backgroundColor: '#E3F5CE' }]}>
      <View style={[styles.iconWrapper, { backgroundColor: '#4CAF50' }]}>
        <RightIcon width={48} height={48} fill="#E3F5CE" />
      </View>
      <Text style={[styles.text, { color: '#4CAF50' }]}>{label}</Text>
    </View>
  )
}

const OrderCancelled = () => {
  return (
    <View style={[styles.section, { backgroundColor: '#FFE8E8' }]}>
      <WrongIcon width={48} height={48} />
      <Text style={[styles.text, { color: '#E53935' }]}>Order Cancelled</Text>
    </View>
  )
}

const OrderFailed = () => {
  return (
    <View style={[styles.section, { backgroundColor: '#FFE8E8' }]}>
      <FailingIcon width={48} height={48} />
      <Text style={[styles.text, { color: '#E53935' }]}>Order Failed</Text>
    </View>
  )
}

const OrderPending = ({
  isPaymentPending = false,
}: {
  isPaymentPending?: boolean
}) => {
  return (
    <View style={[styles.section, { backgroundColor: '#FFF3C2' }]}>
      <PendingIcon width={48} height={48} />
      <Text style={[styles.text, { color: '#8C6500' }]}>
        {isPaymentPending
          ? 'Waiting for Payment Confirmation'
          : 'Order confirmation in pending'}
      </Text>
    </View>
  )
}

const OrderStatus = ({
  deliveryDate,
  status,
  onlinePaymentStatus,
  orderType,
}: Props) => {
  const renderStatus = () => {
    switch (status) {
      case ORDER_STATUS.PreOrder:
      case ORDER_STATUS.Pending:
        if (onlinePaymentStatus === ORDER_STATUS.Pending) {
          return <OrderPending isPaymentPending />
        } else {
          return (
            <OrderSuccessful isPrebook={status === ORDER_STATUS.PreOrder} />
          )
        }

      case ORDER_STATUS.Failed:
      case ORDER_STATUS.OrderFailed:
        return <OrderFailed />
      case ORDER_STATUS.OutForDelivery:
      case ORDER_STATUS.ReadyForDelivery:
      case ORDER_STATUS.VendorConfirmed:
      case ORDER_STATUS.Shipped:
      case ORDER_STATUS.Success:
        return <OrderSuccessful />
      case ORDER_STATUS.Delivered:
        return (
          <OrderDelivered deliveryDate={deliveryDate} orderType={orderType} />
        )
      default:
        return <OrderCancelled />
    }
  }

  return <View>{renderStatus()}</View>
}

const styles = StyleSheet.create({
  section: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 24,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
  },
  iconWrapper: {
    padding: 12,
    borderRadius: 9999,
    marginVertical: 8,
  },
  text: {
    fontWeight: '600',
    fontSize: 16,
  },
  rotating: {
    transform: [{ rotate: '360deg' }],
  },
})

export default OrderStatus
